import Repository from './Repository';


const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/category`;

export default {
  /**
   * Lists all categories
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  list() {
    return Repository.get(`${base}/list`);
  },
};
